<template>
    <div id="contact">
        <div class="container" v-if="eng">
            <h1 class="mb-4 py-4 text-center">Atlanta Telecom Company</h1>

            <h4>Thank you for your interest in doing business with us.</h4>
            <h4 class="mt-4">Please use the form below to send us a message. We will get in touch with you as soon as possible.</h4>
        </div>

        <div class="container" v-else>
            <h1 class="mb-4 py-4 text-center">Atlanta Telecom Company</h1>

            <h4>Gracias por tu interés en nuestros servicios.</h4>
            <h4 class="mt-4">Por favor usa la forma de abajo para enviarnos un mensaje. Estaremos comunicándonos contigo tan pronto como nos sea posible.</h4>
        </div>
    </div>
</template>

<script>
  export default {
    name: "Contact",

    props: ['eng']
  }
</script>

<style lang="sass" scoped>
#contact
    padding-top: 50px
    padding-bottom: 150px
    background-color: rgba(255, 255, 255, 0.6)
    min-height: 50vh
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue